import { AxiosResponse } from "axios";
import { getAxiosInstance } from "./api-utils";

const TEMPLATES = "/templates";

export type TemplateType = "ORDER_COMPLETION";

export type Template = {
    id: number;
    templateType: TemplateType;
    content: string;
    subject: string;
};

export async function getTemplates(): Promise<Template[]> {
    const response: AxiosResponse<Template[]> = await getAxiosInstance().get(TEMPLATES);
    return response.data;
}

export async function getTemplateByType(templateType: TemplateType): Promise<Template> {
    const response: AxiosResponse<Template> = await getAxiosInstance().get(`${TEMPLATES}/${templateType}`);
    return response.data;
}

export async function updateTemplate(id: number, template: Template): Promise<Template> {
    const response: AxiosResponse<Template> = await getAxiosInstance().patch(`${TEMPLATES}/${id}`, template);
    return response.data;
}

/** Server-side render of template content with sample values — same renderer as
 *  real emails, so the editor preview matches exactly (sections included). */
export async function previewTemplate(
    content: string,
    values: Record<string, string>,
    orderId?: number | null,
): Promise<string> {
    const response: AxiosResponse<{ html: string }> = await getAxiosInstance()
        .post(`${TEMPLATES}/preview`, { content, values, orderId: orderId ?? null });
    return response.data.html;
}
